import React from 'react';
import { useLaunchParams } from '@telegram-apps/sdk-react';
import '../../routes/Orders/Orders.scss';
import OrderStatus from '../../components/ui/OrderStatus';
import api from '../../api'; // axios instance
import ApiImage from '../../components/ApiImage';

import { useNavigate } from 'react-router-dom';

const Order = ({ order }) => {
  const navigate = useNavigate();
  return (
    <div className="order-card mini" style={{maxWidth: "100%"}} onClick={() => {navigate(`/order/${order.id}`)}}>
      <div className="order-header">
        <div className="order-date">Заказ от {order.date}</div>
        <div className="order-id">{order.id}</div>
      </div>
      <div className="order-body">
        <div className='order-total-status'>
          <div className="order-total">{order.total}</div>
          <OrderStatus status={order.status} />
        </div>
        <div className="order-images">
          {order.images.map((src, i) => (
            <ApiImage key={i} path={src}></ApiImage>
          ))}
          {order.extraCount > 0 && (
            <div className="order-more">+{order.extraCount}</div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Order;
